import TextBlurb from './TextBlurb';

export default TextBlurb;
